import { render, staticRenderFns } from "./navbar.vue?vue&type=template&id=1b81c287&scoped=true"
import script from "./navbar.vue?vue&type=script&lang=js"
export * from "./navbar.vue?vue&type=script&lang=js"
import style0 from "./navbar.vue?vue&type=style&index=0&id=1b81c287&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b81c287",
  null
  
)

export default component.exports